import gql from 'graphql-tag'
import { ASSET_FIELDS } from 'src/lib/queries/fields'
import { QueryOptions } from 'apollo-client'
import { apolloProvider } from 'boot/apollo'

export function getAssignments (userId: number) {
  const options: QueryOptions = {
    query: gql`
      ${ASSET_FIELDS}
      query assignment($userId: Int!) {
        assignments: item(where: {type: {_eq: ASSIGNMENT}, _and: {item: {item_users: {user_id: {_eq: $userId}}}}}, order_by: {created_at: desc}) {
                id
                created_at
                question: content {
                  id
                  title
                  body
                  assets: content_assets {
                    asset {
                      ...assetFields
                    }
                  }
                }
              }
          }`,
    variables: {
      userId
    },
    fetchPolicy: 'no-cache'

  }
  return apolloProvider.defaultClient.query(options)
}

export function getAssignmentAnswers (userId) {
  const options: QueryOptions = {
    query: gql`
    query get_all_assignment_answers($userId: Int) {
      assignment_answers: user_content(where: {user_id: {_eq: $userId}, type: {_eq: ASSIGNMENT}}) {
        id
        status
        created_at
        assignment_id: context_id
        answer: content {
          id
          title
          body
          content_assets {
            asset {
              class
              description
              id
              is_shared
              type
              url
            }
          }
        }
      }
    }`,
    variables: {
      userId: userId
    },
    fetchPolicy: 'no-cache'
  }
  return apolloProvider.defaultClient.query(options)
}

export function getUserAnswers (assignmentIds) {
  const options: QueryOptions = {
    query: gql`
    query get_assignment_answers($assignmentIds: [bigint!]!) {
      assignment_existing: user_content(where: {context_id: {_in: $assignmentIds}, type:{_eq: ASSIGNMENT}}) {
        id
        context_id
        status
        user {
          id
          firstname
          lastname
        }
        answer: content {
          id
          title
          body
          content_assets {
            asset {
              class
              description
              id
              type
              url
            }
          }
        }
      }
      }`,
    fetchPolicy: 'no-cache',
    variables: {
      assignmentIds: assignmentIds
    }
  }
  return apolloProvider.defaultClient.query(options)
}

export const QUERY_GET_ASSIGNMENT_RECIPIENTS = gql`query get_assignment_recipients($userId: Int!, $assignmentId: Int!) {
  assignment_array: item(where: {_and: [{type: {_eq: ASSIGNMENT}, id: {_eq: $assignmentId}}], item: {type: {_eq: LESSON}, item_users: {user_id: {_eq: $userId}, role_id: {_eq: 5}}}}) {
    id
    users_expected: item {
      users: item_users(where: {role_id: {_eq: 6}}) {
        id: user_id
      }
    }
  }
}

`

export const QUERY_GET_USER_ANSWERS = gql`query get_assignment_answers($assignmentIds: [bigint!]!) {
  assignment_existing: user_content(where: {context_id: {_in: $assignmentIds}, type:{_eq: ASSIGNMENT}}) {
    id
    context_id
    status
    user {
      id
      firstname
      lastname
    }
    answer: content {
      id
      title
      body
      content_assets {
        asset {
          class
          description
          id
          type
          url
        }
      }
    }
  }
}`

export const MUTATION_DISTRIBUTE_ASSIGNMENTS = gql`
  mutation insert_assignments($objects: [user_content_insert_input!]!) {
    insert_user_content(
      objects: $objects
    ) {
      returning {
        id
      }
    }
  }
`

export const QUERY_GET_SCORES_BY_USER = gql`query score_list($users: [Int!]) {
  scores :score(where: {scoree_id: {_in: $users}}) {
    scoree_id
    score
    feedback
    context_id
    context_type
    updated_at
  }
}
`

export const QUERY_ASSIGNMENT_BY_USER = gql`
  ${ASSET_FIELDS}
  query assignment($userId: Int!) {
    assignments: item(where: {type: {_eq: ASSIGNMENT}, _and: {item: {item_users: {user_id: {_eq: $userId}}}}}) {
      id
      question: content {
        id
        title
        body
        assets: content_assets {
          asset {
            ...assetFields
          }
        }
      }
    }
}`

export const QUERY_GET_ALL_ASSIGNMENTS = gql`
  ${ASSET_FIELDS}
  query assignment($userId: Int!) {
    assignments: item(where: {
      type: {_eq: ASSIGNMENT},
      _and: {
        item: {
          item_users: {
            user_id: {_eq: $userId}
          }
        }
      }
    }
    ) {
      id
      created_at
      question: content {
        title
        body
        assets: content_assets {
          asset {
            ...assetFields
          }
        }
      }
    }
  }`

export const QUERY_GET_ALL_ASSIGNMENT_ANSWERS = gql`query get_all_assignment_answers($userId: Int) {
  assignment_answers: user_content(where: {user_id: {_eq: $userId}, type: {_eq: ASSIGNMENT}}) {
    id
    status
    created_at
    assignment_id: context_id
    answer: content {
      id
      title
      body
      content_assets {
        asset {
          class
          description
          id
          is_shared
          type
          url
        }
      }
    }
  }
}
`

export const QUERY_GET_UNANSWERED_ASSIGNMENT_COUNT = gql`query get_unanswered_assignments($userId: Int!) {
  unanswered_count: user_content_aggregate(
    where:
      {
        type:{_eq: ASSIGNMENT},
        _and: [
          { user_id: { _eq:$userId}},
          { status: { _eq: DRAFT}}
        ]
      }
    ) {
    aggregate {
      count
    }
  }
}
`

export const MUTATION_UPDATE_ASSIGNMENT_ANSWER = gql`
  mutation answer_assignment($datetimenow: timestamptz, $answer: String, $id: Int, $status: enum_general_status_enum) {
    update_content(_set: {body: $answer, updated_at: $datetimenow}, where: {id: {_eq: $id}}) {
      affected_rows
    }

    update_user_content(_set: {status: $status}, where: {content_id: {_eq: $id}}) {
      affected_rows
    }
  }`

export const MUTATION_SCORE_ASSIGNMENT = gql`
  mutation score_assignment($contextId: Int!, $feedback: String, $score: Int, $userId: Int, $status: enum_general_status_enum) {
    insert_score(objects: {score: $score, scoree_id: $userId, scoree_type: USER, type: WORKSHEET, context_id: $contextId, context_type: USER_CONTENT, feedback: $feedback}) {
      affected_rows
    }

    update_user_content(_set: {status: $status}, where: {content_id: {_eq: $contextId}}) {
      affected_rows
    }
  }`

export const MUTATION_INSERT_ASSIGNMENT_ATTACHMENT = gql`
  mutation insert_answer_attachment($id: Int, $description: String, $class: enum_asset_class_enum, $is_shared: Boolean, $type: enum_asset_type_enum, $url: String) {
    insert_asset(objects: {
      class: $class,
      description: $description,
      is_shared: $is_shared,
      type: $type,
      url: $url,
      content_assets: {
        data: {
          content_id: $id
        }
      }
    })
    {
      affected_rows
    }
  }
`

export const MUTATION_DELETE_CONTENT_ASSET = gql`
  mutation delete_content_asset($contentId: Int!, $assetId: Int!) {
    delete_content_asset(where: {content_id: {_eq: $contentId}, asset_id: {_eq: $assetId}}) {
      affected_rows
    }
  }
`

export const MUTATION_DELETE_ASSET = gql`
  mutation delete_asset($id: Int!) {
    delete_asset(where: {id: {_eq: $id}}) {
      affected_rows
    }
  }
`
